var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    attrs: {
      "tile": "",
      "color": "secondary"
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query['mode_auction'],
      callback: function callback($$v) {
        _vm.$set(_vm.query, 'mode_auction', $$v);
      },
      expression: "query['mode_auction']"
    }
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-btn', {
      key: item.value,
      staticClass: "px-6",
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }